import React from 'react';
import {Grid, Segment, Image, Header} from 'semantic-ui-react';
import './Challenges.css';

export default (props) => {
    var {name, header, subheader_1, handleChallengeClick} = props;
    return <Grid.Column>
        <Segment name={name} basic className="challenge" onClick={(e) => handleChallengeClick(e, name)}>
            <Image draggable="false" className="circle-image" src={props.image} />
            <Header style={{ margin: "0.5rem auto", maxWidth: "280px"}}>
                <Header.Content>
                    <span style={{fontWeight: 500, color: "#E21F14"}}>{header}</span>
                    <Header.Subheader style={{fontWeight: 400}}>
                        {subheader_1}
                    </Header.Subheader>
                </Header.Content>
            </Header>
        </Segment>
    </Grid.Column>
}


// WEBPACK FOOTER //
// ./src/components/challenges/Challenge.jsx